import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/moment/:slug',
        name: 'MomentDetails',
        component: () => import(/* webpackChunkName: "momentDetails" */ '../views/MomentDetails'),
        props: true,
        children: [
            {
                path: ':subMomentSlug',
                name: 'SubMomentDetails',
                component: () => import(/* webpackChunkName: "subMomentDetails" */ '../views/SubMomentDetails'),
                props: true
            }
        ]
    },
    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        return new Promise((resolve) => {
            setTimeout(() => {
                if (savedPosition) {
                    resolve(savedPosition);
                } else {
                    const position = {};
                    if (to.hash) {
                        position.selector = to.hash;
                        if (to.hash === "#subMoment") {
                            position.offset = { y: 80 };
                        }
                        if (document.querySelector(to.hash)) {
                            resolve(position);
                        }
                        return false;
                    } else {
                        resolve({ x: 0, y: 0 });
                    }
                }
            }, 250);
        });
    },
    routes
});

router.afterEach((to) => {
    // Update dynamically google analytics
    // eslint-disable-next-line
    gtag('config', 'UA-167226741-1', { 'page_path': to.path });

    const webTitle = 'Garcia Lozano Family';
    if (to.name === 'Home') {
        return document.title = webTitle;
    }

    if (to.name === 'About') {
        return document.title = `Sobre Nosotros | ${webTitle}`;
    }


    const hasSlugProperty = Object.prototype.hasOwnProperty.call(to.params, 'slug');
    if (hasSlugProperty) {
        if (to.params.slug === 'vacation') {
            return document.title = `Vacaciones | ${webTitle}`;
        }

        if (to.params.slug === 'wedding') {
            return document.title = `Boda | ${webTitle}`;
        }

        if (to.params.slug === 'births') {
            return document.title = `Nacimientos | ${webTitle}`;
        }

        if (to.params.slug === 'anniversaries') {
            return document.title = `Aniversarios | ${webTitle}`;
        }
        
        let slug = to.params.slug === 'yom-hatzmaut' ? slug = 'Yom Hatzmaut' : slug = to.params.slug[0].toUpperCase() + to.params.slug.substring(1); // Capitalize slug
        return document.title = `${slug} | ${webTitle}`;
    }
});

export default router;
